<template>
  <b-container fluid id="form-container">
    <b-row>
      <b-col>
        <h1>Submitter</h1>

        <div>
          <b-row>
            <AppNav :applicationId="appId"></AppNav>
          </b-row>
          <b-form id="pgContainer" tabindex="-1">
            <div class="card" v-if="application">
              <div class="card">
                <div class="card-header">Application Info</div>
                <div class="card-body">
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Program:</span> {{ application.appName.programNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Type:</span> {{ application.appName.applicationTypeNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Sub Type:</span> {{ application.appName.applicationSubTypeNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Number:</span> {{ application.applicationNumber }}</b-col>
                  </b-row>
                </div>
              </div>
              <div class="card-header">Submitter Information</div>
              <div class="card-body">
                <b-row>
                  <b-col cols="6">
                    <BaseTextInput v-model="application.submitter.lastName"
                                   :v="$v.application.submitter.lastName"
                                   slug="lastName"
                                   label="Last Name"
                                   setId="submitterLastName"
                    />
                  </b-col>
                  <b-col cols="6">
                    <BaseTextInput v-model="application.submitter.firstName"
                                   :v="$v.application.submitter.firstName"
                                   slug="firstName"
                                   label="First Name"
                                   setId="submitterFirstName"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <BaseMaskedTextInput v-model="application.submitter.phone"
                                         :v="$v.application.submitter.phone"
                                         slug="phone"
                                         label="Phone"
                                         setId="submitterPhone"
                                         mask="###-###-####"
                    />
                  </b-col>
                  <b-col cols="6">
                    <BaseTextInput v-model="application.submitter.email"
                                   :v="$v.application.submitter.email"
                                   slug="email"
                                   label="Email"
                                   setId="submitterEmail"
                    />
                  </b-col>
                </b-row>
              </div>
            </div>
            <b-row class="float-right">
              <b-col>
                <b-button type="button" variant="secondary" to="/dashboard" role="button" class="mr-1">Cancel</b-button>
                <b-button type="button" variant="success" class="mr-1" @click="saveApplication">Save Submitter</b-button>
                <b-button type="button" variant="primary" class="mr-1" @click="saveApplicationContinue">Save & Continue</b-button>
                <b-button @click="submitApplication" variant="primary">Submit Application</b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { required, requiredIf, maxLength, minLength, email } from 'vuelidate/lib/validators'
  import router from "@/router";
  import ConfigService from "@/services/ConfigService";
  import AppNav from "@/components/templates/AppNav";

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
  components: {AppNav},
  data: () => ({
    appId: null,
    application: null,
  }),

  created() {
    document.title = "Submitter - Facility and Provider Licensing System"
    this.appId = this.$route.params.id
    this.loadApplication()
  },
  mounted() {
    document.getElementById('pgContainer').focus()
  },
  methods: {
    loadApplication() {
      axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId)
      .then(response => {
        this.application = response.data
      })
    },
    saveApplication() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          document.getElementById('form-container').scrollIntoView()
        })
        return
      }
      axios.put(ConfigService.getApiUrl() + `/api/applications/`+this.application.id + '/submitter', this.application.submitter)
        .then(response => {
          this.showRootToast("Saved", "Application saved", "success")
      })
    },
    saveApplicationContinue() {
      this.saveApplication()
      if (!this.$v.$invalid) {
        setTimeout(() => {
          router.push("/contacts/" + this.appId)
        }, 200)
      }
    },
    submitApplication() {
      this.saveApplication()
      axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/submit')
        .then(response => {
          this.showRootToast("Submitted", "Application successfully submitted", "success")
          setTimeout(() => {
            router.push("/dashboard")
          }, 200)
        }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
    },

    createErrorToast(errors) {
      const h = this.$createElement
      const errNodes = h(
              'div',
              [
                h('p','Application contains errors, please fix and resubmit'),
                h('ul', [
                  errors.map(e => {
                    return h('li', {attrs:{class: 'circle-list ml-4'}}, e)
                  })
                ])
              ]
      )
      return errNodes
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true,
        noAutoHide:true
      })
      this.toastFocus()
    },
    toastFocus() {
      setTimeout(() => {
        let elem = document.getElementsByClassName("toast")
        elem = elem[elem.length-1]
        elem.focus()
      }, 100)
    },
  },

  validations() {
    return {
      application: {
        submitter: {
          lastName: { required, maxLength: maxLength(50) },
          firstName: { required, maxLength: maxLength(50) },
          phone: { required, maxLength: maxLength(12), minLength: minLength(12) },
          email: { required, email }
        },
      },
    }
  },
}
</script>
<style>
  .b-toast, #minToast {
    max-width: initial !important;
  }
</style>
